import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { TaskState, TaskStore } from './task-store.service';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TaskQuery extends QueryEntity<TaskState> {
  lockedEmployees$ = this.select((s) => s.lockedEmployees);

  constructor(protected store: TaskStore) {
    super(store);
  }

  selectTask(taskId: number) {
    return this.selectEntity(taskId).pipe(
      distinctUntilChanged(
        (previous, current) => previous?.timestamp === current?.timestamp,
      ),
    );
  }

  selectTasksWithProjectId(projectId: number) {
    return this.selectAll({ filterBy: (entity) => entity.projectId === projectId });
  }
}
